import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Woodbury",
  metaDescription: "Trusted plumber in Woodbury, MN. Bruce Nelson Plumbing & Heating offers expert residential and commercial plumbing services. Call 651-738-9354 today.",
  heroTitle: "Plumber in Woodbury, MN",
  heroSubtitle: "Quality plumbing services for Woodbury's growing community.",
  introduction: "Woodbury homeowners and businesses trust Bruce Nelson Plumbing & Heating for all their plumbing needs. As one of Minnesota's fastest-growing cities, Woodbury deserves a plumber who understands both new construction and established homes. From Eagle Valley to the Wedgewood area, we provide prompt, professional service throughout Woodbury.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Expert plumbing services for Woodbury homes of all ages and sizes.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Reliable plumbing solutions for Woodbury's thriving business community.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Professional boiler maintenance and repair for Woodbury properties.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Fast water heater service throughout Woodbury neighborhoods.",
      link: "/services/water-heaters"
    },
    {
      title: "New Construction",
      description: "Plumbing installation for Woodbury's new home construction projects.",
      link: "/services/residential"
    },
    {
      title: "Remodeling Services",
      description: "Kitchen and bathroom remodeling plumbing for Woodbury homes.",
      link: "/services/remodeling"
    }
  ],
  whyChooseUs: [
    "Serving Woodbury families for nearly 50 years",
    "Experience with both new and established Woodbury homes",
    "Licensed, bonded, and fully insured",
    "Upfront pricing - no hidden fees",
    "Fast response to all Woodbury neighborhoods",
    "Top-rated by Woodbury homeowners"
  ],
  serviceAreas: [
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Cottage Grove", link: "/plumber-cottage-grove" },
    { name: "Lake Elmo", link: "/plumber-lake-elmo" },
    { name: "Maplewood", link: "/plumber-maplewood" },
    { name: "Newport", link: "/plumber-newport" }
  ],
  testimonial: {
    text: "We moved to Woodbury last year and needed a reliable plumber. BNPH has been fantastic - professional, prompt, and fairly priced. Highly recommend!",
    author: "Jennifer L."
  }
};

const WoodburyPage = () => <CityPageTemplate cityData={cityData} />;

export default WoodburyPage;
